import React from 'react';

export default function VerifiedFlame({ size = 16, title = 'Verified by ProZpects', label = 'Verified', style = {}, onClick }) {
  return (
    <span
      className="verified-badge"
      title={title}
      style={{ ...style, ...(onClick ? { cursor: 'pointer' } : {}), display: 'inline-flex', alignItems: 'center' }}
      role="img"
      aria-label={label}
      onClick={onClick}
    >
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: 'middle' }}>
        {/* checkmark.seal.fill — badge/seal shape matching iOS */}
        <path d="M12 1.5l2.09 2.09 2.91-.75 1.07 2.84 2.84 1.07-.75 2.91L22.5 12l-2.34 2.34.75 2.91-2.84 1.07-1.07 2.84-2.91-.75L12 22.5l-2.09-2.09-2.91.75-1.07-2.84-2.84-1.07.75-2.91L1.5 12l2.34-2.34-.75-2.91 2.84-1.07 1.07-2.84 2.91.75z" fill="#007AFF"/>
        <path d="M8.5 12.5l2.2 2.2 4.8-5" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </span>
  );
}
